export default class SelectState {
    #element
    #watchedElement
    #watchedValue
    #inverse = false

    constructor(element) {
        this.#element = element
        console.log(element.dataset)
        this.#watchedElement = document.getElementById(element.dataset.target)
        this.#watchedValue = element.dataset.targetValue
        this.#inverse = element.dataset.hasOwnProperty('inverse')

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new SelectState(element))
    }

    #bindEvents() {
        this.#handleChange()
        this.#watchedElement.addEventListener('change', this.#handleChange)
    }

    #handleChange = () => {
        let value = this.#watchedElement.value
        let shouldEqual = !this.#inverse

        if (value === this.#watchedValue && shouldEqual) {
            this.#element.style.display = ''
        } else {
            this.#element.style.display = 'none'
        }
    }
}
